import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.educational-material': {
         paramedicalProfessionsMap: {
            ADDICTION_PSYCHOTHERAPY_SPECIALIST: 'specjalista psychoterapii uzależnień',
            DIETITIAN: 'dietetyk',
            OTHER: 'inny',
            PSYCHOLOGIST: 'psycholog',
            PSYCHOTHERAPIST: 'psychoterapeuta',
            UNKNOWN: 'nieznany',
         },
      },
   },
};

export const translationKeys = createScopedTranslationKeys(
   translations.pl,
   '~libs.desktop.shared.educational-material'
);
